// extracted by mini-css-extract-plugin
export default {"container":"PharmacyOrdersInbox_container__H9Ux+","footer":"PharmacyOrdersInbox_footer__DhLyX","filedStatus":"PharmacyOrdersInbox_filedStatus__XgIb0"};